import { Button, Typography } from '@mui/material';
import { Platform } from '../../constants/platform';

interface CancelButtonProps {
  onClick: () => void;
  label: string;
}

export function CancelButton({ onClick, label }: CancelButtonProps) {
  return (
    <Button
      variant='outlined'
      sx={{
        display: 'flex',
        width: '98px',
        padding: '10px 12px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4px',
        alignSelf: 'stretch',
        borderRadius: '48px',
        border: '1px solid #E3E3E3',
        background: '#FFF',
        '&.Mui-disabled': {
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
          cursor: 'not-allowed',
          pointerEvents: 'all !important', // Override pointer-events: none
        },
      }}
      onClick={onClick}
      disabled={Platform?.isInspect()}
    >
      <Typography
        variant='body1'
        sx={{
          color: Platform?.isInspect() ? 'white' : '#343330',
          fontFamily: 'Montserrat',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '28px' /* 200% */,
        }}
      >
        {label}
      </Typography>
    </Button>
  );
}

interface SubmitButtonProps {
  onClick: () => void;
  disabled: boolean;
}

export function SubmitButton({ onClick, disabled }: SubmitButtonProps) {
  return (
    <Button
      variant='contained'
      sx={{
        display: 'flex',
        width: '98px',
        padding: '10px 12px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4px',
        alignSelf: 'stretch',
        borderRadius: '48px',
        border: '1px solid #E3E3E3',
        backgroundColor: '#53b50a',
        '&:hover': {
          backgroundColor: '#388007',
        },
      }}
      disabled={disabled}
      onClick={onClick}
    >
      <Typography
        variant='body1'
        sx={{
          color: '#FFF',
          fontFamily: 'Montserrat',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '28px' /* 200% */,
        }}
      >
        Submit
      </Typography>
    </Button>
  );
}
